import React,  {Component} from 'react'
import Sidebar from './Sidebar'
import SignIn from './SignIn'
import Notifications from './Notifications'
import { Container, Row, Col, Spinner, Badge} from 'reactstrap';
import StdButton from '../StdButton'
import {Trans, withTranslation} from "react-i18next";
import {LogOut} from 'react-feather';
import toastr from 'toastr'
class Layout extends Component {

  constructor(props){
	  super(props)
	  this.state = {toggle: false}
  }
  
  componentDidMount(){
	  this.props.getCurrentUser()	
  }
  componentDidUpdate(prevProps){
	  const {t} = this.props
	  const difference = [...this.props.errors].slice(prevProps.errors.length, this.props.errors.length)

	  if(difference.length > 0)
	    for  (let error of difference) {		
		    toastr.error(t(`errors.${error}`), t('errors.error'));
	    }
  }
  render() {
	  

	  const {current_user,signInUser,signOutUser, loading} = this.props
	  const {toggle} = this.state

	  if(current_user === undefined)
	    return <div className="loadPage">
		    <div>
		      <Spinner color="primary" />
		    </div>
	    </div>	    
	    else if(current_user.authorized === true)
	    return (
	    <div>
		    {loading &&
		     <div className='loadPage loader-overlay'>
		       <Spinner color="primary" />
		     </div>
		    }
		    
		    <div className="wrapper">		      
		      <Sidebar toggle={toggle} current_user={current_user} />
		      <div className="main">
			      <nav className="navbar navbar-expand navbar-light bg-white">
			        <StdButton buttonAction={async () => this.setState({toggle: !toggle}) } >
				        <span className="sidebar-toggle d-flex mr-2"><i className="hamburger align-self-center"></i></span>
			        </StdButton>
			        
			        <div className= "logout-button">
				        {false &&  <Notifications /> }
				        Ciao {current_user.info.name} <Badge color="primary" pill>hai <Trans values={{value: current_user.info.total_credits}}>standard_formatting.number</Trans> crediti</Badge>
				        <StdButton  buttonAction={signOutUser} >
				          <Trans>login.logout</Trans>
				          <LogOut />
				        </StdButton>
			        </div>
			      </nav>
			      
			      <div className="content">
			        {this.props.children}
			      </div>
		      </div>


		    </div>
	    </div>)
	  else
	    return <div className="sign_in_container"><SignIn signInAction={signInUser} current_user={current_user} /></div>
	  
  }
}



export default withTranslation()(Layout)
